var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.error)?_c('div',{staticClass:"rv-error",style:({ 
    width: _vm.imageClipper.displaySize[0] + 'px',
    height: _vm.imageClipper.displaySize[1] + 'px',
    left: _vm.imageClipper.displayOffset[0] + 'px',
    top: _vm.imageClipper.displayOffset[1] + 'px',
    })},[_vm._t("error")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }